module.exports = __webpack_public_path__ + "static/media/undraw_slider.1804258a.svg";